"use client";

import { makeStore } from "@/lib/store";
import { useEffect, useRef } from "react";
import { Provider } from "react-redux";
import { AppProgressBar as ProgressBar } from "next-nprogress-bar";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "@/components/ErrorFallback";

export default function StoreProvider({ children }) {
  const storeRef = useRef();

  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = makeStore();
  }

  // useEffect(() => {
  //   const handleChunkError = (event) => {
  //     const isChunkError =
  //       event?.message?.includes("Loading chunk") ||
  //       (event?.type === "error" && event?.target?.tagName === "SCRIPT");

  //     if (isChunkError) {
  //       console.warn("ChunkLoadError detected, reloading page...");
  //       window.location.reload();
  //     }
  //   };

  //   window.addEventListener("error", handleChunkError);
  //   return () => window.removeEventListener("error", handleChunkError);
  // }, []);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Provider store={storeRef.current}>
        <ProgressBar
          height="2px"
          color="#F90"
          options={{ showSpinner: false }}
          shallowRouting
        />
        {children}
      </Provider>
    </ErrorBoundary>
  );
}
